import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ItemTypeDTO } from '../models/itemTypeDto';
import { environment, MyHttpClientFactory, DataService } from '@ups/xplat/core';

@Injectable({
  providedIn: 'root',
})
export class ItemTypeService extends DataService<ItemTypeDTO> {
  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/itemtype',
      httpClient,
      httpFactory
    );
  }
}
